import { NoddiInfoBanner } from 'noddi-ui-web';
import { NoticeUpdatedAt, type NoticeBannerNotice } from './NoticeUpdatedAt';
import { type NoticeActorTranslations, type NoticeBannerTranslations } from './noticeBannerTranslations';
import { NOTICE_SEVERITY_BANNER_VARIANT } from './noticeSeverity';

type Props = {
  notices: NoticeBannerNotice[];
  className?: string;
  translations?: NoticeBannerTranslations | NoticeActorTranslations;
};

export const NoticeBannerList = ({ notices, className, translations }: Props) => {
  if (!notices.length) {
    return null;
  }

  return (
    <div className={className}>
      {notices.map((notice) => (
        <NoddiInfoBanner
          key={notice.id}
          size='small'
          variant={NOTICE_SEVERITY_BANNER_VARIANT[notice.severity]}
          title={notice.title || undefined}
          texts={[{ value: notice.message }]}
          footer={<NoticeUpdatedAt notice={notice} translations={translations} />}
        />
      ))}
    </div>
  );
};
